import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { ToastActionElement, ToastProps } from "@/components/ui/toast"
import * as React from "react"

const TOAST_LIMIT = 1

export type ToasterToast = {
  id: string
  title?: React.ReactNode
  description?: React.ReactNode
  action?: ToastActionElement
  variant?: ToastProps["variant"]
  duration?: number
  open?: boolean
}

interface LayoutState {
  toasts: ToasterToast[]
}

const initialState: LayoutState = {
  toasts: [],
}

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    addToast: (state, action: PayloadAction<ToasterToast>) => {
      state.toasts = [action.payload, ...state.toasts].slice(0, TOAST_LIMIT)
    },
    updateToast: (state, action: PayloadAction<Partial<ToasterToast>>) => {
      state.toasts = state.toasts.map((t) => (t.id === action.payload.id ? { ...t, ...action.payload } : t))
    },
    dismissToast: (state, action: PayloadAction<{ toastId?: string }>) => {
      const { toastId } = action.payload
      state.toasts = state.toasts.map((t) =>
        t.id === toastId || toastId === undefined
          ? {
              ...t,
              open: false,
            }
          : t
      )
    },
    removeToast: (state, action: PayloadAction<{ toastId?: string }>) => {
      if (action.payload.toastId === undefined) {
        state.toasts = []
      } else {
        state.toasts = state.toasts.filter((t) => t.id !== action.payload.toastId)
      }
    },
  },
})

export const { addToast, updateToast, dismissToast, removeToast } = layoutSlice.actions

export default layoutSlice.reducer
